
 <template>
  <div>
    <!-- 面包屑导航 -->
    <div class="flex-spc-x fixed">
      <el-breadcrumb separator-class="el-icon-arrow-right" style="postion:fixed">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/setting/setting' }">系统设置</el-breadcrumb-item>
        <el-breadcrumb-item>{{WZCDName}}配置</el-breadcrumb-item>
      </el-breadcrumb>
      <el-link type="primary" style="margin-right:220px" @click="tosetting()"><i class="el-icon-back"></i> 返回</el-link>
    </div>

    <div>
       <div class="flex-spc-x" style="width:100%;padding-top:30px;padding-bottom:50px">
            <el-table
                             :data="SettingList"
                             tooltip-effect="dark"
                             border
                             stripe
                             style="width: 100%">
                            <el-table-column type="index" label="序号" align="center" width=""></el-table-column>
                             <el-table-column label="名称" prop="name"></el-table-column>
                            <el-table-column  label="有效值"  >
                                 <template slot-scope="scope">
                                  <span v-if="scope.row.isEdit=='0'">  {{scope.row.effective}}</span>
                                  <el-select v-model="scope.row.info"  v-if="scope.row.isEdit=='1' && scope.row.sType=='3' " >
                                    <el-option label="15" value="15"></el-option>
                                     <el-option label="30" value="30"></el-option>
                                     <el-option label="45" value="45"></el-option>
                                     <el-option label="60" value="60"></el-option>
                                 </el-select>
                                  <el-select v-model="SelectDay"  v-if="scope.row.isEdit=='1' && scope.row.sType=='10'"  @change="changeV" >
                                    <el-option label="当天" value="0"></el-option>
                                    <el-option label="提前一天" value="1"></el-option>
                                    <el-option label="提前两天" value="2"></el-option>
                                    <el-option label="提前三天" value="3"></el-option>  
                                    <el-option label="提前四天" value="4"></el-option>
                                    <el-option label="提前五天" value="5"></el-option>
                                    <el-option label="提前六天" value="6"></el-option>
                                    <el-option label="提前七天" value="7"></el-option>
                                </el-select> 
                                 <el-select v-model="Selecttimes"  v-if="scope.row.isEdit=='1' && scope.row.sType=='10' && SelectDay =='0'"  >
                                    <el-option label="30" value="30"></el-option>
                                    <el-option label="45" value="45"></el-option>
                                    <el-option label="60" value="60"></el-option>
                                    <el-option label="90" value="90"></el-option>
                                    <el-option label="120" value="120"></el-option>
                                    <el-option label="150" value="150"></el-option>
                                    <el-option label="180" value="180"></el-option>
                                 </el-select>
                               
                                   <el-select v-model="Selecttimes"  v-if="scope.row.isEdit=='1' && scope.row.sType=='10' && SelectDay !='0'"  >
                                    <el-option label="05:00" value="05:00"></el-option>
                                    <el-option label="06:00" value="06:00"></el-option>
                                    <el-option label="07:00" value="07:00"></el-option>
                                    <el-option label="08:00" value="08:00"></el-option>
                                    <el-option label="09:00" value="09:00"></el-option>
                                    <el-option label="10:00" value="10:00"></el-option>
                                    <el-option label="11:00" value="11:00"></el-option>
                                    <el-option label="12:00" value="12:00"></el-option>
                                    <el-option label="13:00" value="13:00"></el-option>
                                    <el-option label="14:00" value="14:00"></el-option>
                                    <el-option label="15:00" value="15:00"></el-option>
                                    <el-option label="16:00" value="16:00"></el-option>
                                    <el-option label="17:00" value="17:00"></el-option>
                                    <el-option label="18:00" value="18:00"></el-option>
                                    <el-option label="19:00" value="19:00"></el-option>
                                    <el-option label="20:00" value="20:00"></el-option>
                                    <el-option label="21:00" value="21:00"></el-option>
                                    <el-option label="22:00" value="22:00"></el-option>
                                </el-select> 
                                  <el-select v-model="Selecttimesmt"  v-if="scope.row.isEdit=='1' && scope.row.sType=='16'"  >
                                    <el-option label="00:30" value="00:30"></el-option>
                                    <el-option label="01:00" value="01:00"></el-option>
                                    <el-option label="01:30" value="01:30"></el-option>
                                    <el-option label="02:00" value="02:00"></el-option>
                                    <el-option label="02:30" value="02:30"></el-option>
                                    <el-option label="03:00" value="03:00"></el-option>
                                    <el-option label="03:30" value="03:30"></el-option>
                                    <el-option label="04:00" value="04:00"></el-option>
                                    <el-option label="04:30" value="04:30"></el-option>
                                    <el-option label="05:00" value="05:00"></el-option>
                                    <el-option label="05:30" value="05:30"></el-option>
                                    <el-option label="06:00" value="06:00"></el-option>
                                    <el-option label="06:30" value="06:30"></el-option>
                                    <el-option label="07:00" value="07:00"></el-option>
                                    <el-option label="07:30" value="07:30"></el-option>
                                    <el-option label="08:00" value="08:00"></el-option>
                                    <el-option label="08:30" value="08:30"></el-option>
                                    <el-option label="09:00" value="09:00"></el-option>
                                    <el-option label="09:30" value="09:30"></el-option>
                                    <el-option label="10:00" value="10:00"></el-option>
                                    <el-option label="10:30" value="10:30"></el-option>
                                    <el-option label="11:00" value="11:00"></el-option>
                                    <el-option label="11:30" value="11:30"></el-option>
                                    <el-option label="12:00" value="12:00"></el-option>
                                    <el-option label="12:30" value="12:30"></el-option>
                                    <el-option label="13:00" value="13:00"></el-option>
                                    <el-option label="13:30" value="13:30"></el-option>
                                    <el-option label="14:00" value="14:00"></el-option>
                                    <el-option label="14:30" value="14:30"></el-option>
                                    <el-option label="15:00" value="15:00"></el-option>
                                    <el-option label="15:30" value="15:30"></el-option>
                                    <el-option label="16:00" value="16:00"></el-option>
                                    <el-option label="16:30" value="16:30"></el-option>
                                    <el-option label="17:00" value="17:00"></el-option>
                                    <el-option label="17:30" value="17:30"></el-option>
                                    <el-option label="18:00" value="18:00"></el-option>
                                    <el-option label="18:30" value="18:30"></el-option>
                                    <el-option label="19:00" value="19:00"></el-option>
                                    <el-option label="19:30" value="19:30"></el-option>
                                    <el-option label="20:00" value="20:00"></el-option>
                                    <el-option label="20:30" value="20:30"></el-option>
                                    <el-option label="21:00" value="21:00"></el-option>
                                    <el-option label="21:30" value="21:30"></el-option>
                                    <el-option label="22:00" value="22:00"></el-option>
                                    <el-option label="22:30" value="22:30"></el-option>
                                    <el-option label="23:00" value="23:00"></el-option>
                                    <el-option label="23:30" value="23:30"></el-option>
                                </el-select> 
                                  <!-- <el-input placeholder="请输入"  v-if="scope.row.isEdit=='1' && scope.row.sType=='3' " v-model="scope.row.info" ></el-input>   -->
                            </template>
                            </el-table-column>
                            <el-table-column label="操作" align="center" width="">
                            <template slot-scope="scope">
                             <el-button type="text" @click="editSeetingClick(scope.row)" v-if="scope.row.Ison && scope.row.isEdit=='0 ' && scope.row.sType !='9'" >修改</el-button>
                             <el-button type="primary" size="medium" @click="editsaverClick(scope.row)" v-if="scope.row.Ison && scope.row.isEdit=='1' && (scope.row.sType =='3' ||scope.row.sType =='10'||scope.row.sType =='16' )">保存</el-button>
                             <el-button type="default"  @click="editcancelClick(scope.row)" v-if="scope.row.Ison && scope.row.isEdit=='1' ">取消</el-button>
                                <el-switch 
                                     v-model="scope.row.Ison"
                                     on-color="#00A854"
                                     on-text="启动"
                                     on-value="1"
                                     off-color="#F04134"
                                     off-text="禁止"
                                     off-value="0"
                                     @change="changeSwitch(scope.row)">
                                </el-switch>
                            </template>
                        </el-table-column>
                        </el-table>
        
    </div>
    </div>
    <el-drawer
            class="normalDrawer"
            title="设置休馆周期"
            direction="ltr"
            size="60%"
            :visible.sync="showDrawerzq"
            :wrapperClosable="false"
            >
            <div class="drawerForm">
                <el-form   label-width="150px" label-position="right">
                      <el-form-item label="周期：" prop="Cycle" >
                        <el-checkbox-group v-model="checkedCycles" @change="handleChange">
                            <el-checkbox v-for="item in CycleList" :label="item.Id" :key="item.index" name="Cycle">
                                {{item.Label}}
                            </el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" size="medium" @click="saveCycles">保 存</el-button>
                        <el-button @click="showDrawerzq = false">取消</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </el-drawer>
        <el-drawer
            class="normalDrawer"
            title="临时放假设置"
            direction="ltr"
            size="50%"
            :visible.sync="showqjszRightDrawer"
            :wrapperClosable="false"
            >
            <div class="drawerForm drawerMemberWrap">
             <div class="drawerTable">
                <div class="flexS right">
                    <el-button icon="el-icon-plus"  type="primary" @click="addQjtimeClick">添加临时时间</el-button>
                   </div>
                   <p class="tableTitle">请假时间列表</p>
                    
                         <el-table :data="SiteLStimeList"   :row-key="row => row.index" :header-cell-style="{'background-color':'#f8f8f8'}">
              
                            
                           
                              <el-table-column label="时间" prop="LsTime"  ></el-table-column>
                                <el-table-column label="操作" align="center"  width="180">
                                <template slot-scope="scope" class="flexB">
                                     <el-button type="text" @click="deleteQjtimeClick(scope.row)"  >删除</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
            </div>
        </el-drawer>
         <el-dialog
      title="提示"
      :visible.sync="dialogqjszVisible"
      width="360px"
      center
      >
       <span slot="title">
        <p>
          添加临时时间
        </p>
      </span>
      <div class="flexC">
          <span style="margin-top:5px;">开始时间: </span> &nbsp;
          <el-date-picker  v-model="sTime"
                            type="date"
                            placeholder="开始时间"
                             value-format="yyyy/MM/dd">
                        </el-date-picker> 
      </div>
      <br>
         <div class="flexC">
          <span style="margin-top:5px;">结束时间: </span> &nbsp;
          <el-date-picker  v-model="eTime"
                            type="date"
                            placeholder="结束时间"
                             value-format="yyyy/MM/dd">
                        </el-date-picker> 
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogqjszVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveqjtime">保 存</el-button>
      </span>
    </el-dialog>
    </div> 
</template>
<script>
import CropperImage from "../../components/CropperImage";
import Pagination from '../../components/Pagination'
export default {
  data() {
    return {
 
    DianList:[],
    checkedCycles:[],
    SiteLStimeList:[],
    sTime:'',
    eTime:'',
    StopCycle:'',
    CycleList:[
                    {Id:"1",Label:"周一"},
                    {Id:"2",Label:"周二"},
                    {Id:"3",Label:"周三"},
                    {Id:"4",Label:"周四"},
                    {Id:"5",Label:"周五"},
                    {Id:"6",Label:"周六"},
                    {Id:"7",Label:"周日"}
                ],
    SelectStoresID:localStorage.getItem("StoresID"),
    tableLoading:false,
    showDrawerzq:false,
    showqjszRightDrawer:false,
    dialogqjszVisible:false,
    overtype:0,
    Selecttimesmt:"",
    SelectDay:"0",
    SiteSettingID:"0",
    Selecttimes:"",
    SelectCDtimes:"",
    BirthdayNumber:'',
    SettingList:[],
        WZYGName:'',
    WZHYName:'',
    WZXMName:'',
    WZPBName:'',
    WZCDName:'',
      formInline: {
        page: 1,
        limit: 10,
        varLable: '',
        varName: '',
        token: localStorage.getItem('logintoken')
      }
    
    }
  },
  // 注册组件
  components: {
    Pagination,
     CropperImage,
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {

    this.WZYGName = localStorage.getItem('WZYGName')
    this.WZHYName = localStorage.getItem('WZHYName')
    this.WZXMName = localStorage.getItem('WZXMName')
    this.WZPBName = localStorage.getItem('WZPBName')
    this.WZCDName = localStorage.getItem('WZCDName'), 

    this.getList()
    
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
  
      tosetting(){
        this.$router.go(-1)
      },changeV(){
      if(this.SelectDay == 0){

          this.Selecttimes = '1'  

      } else {
        
        this.Selecttimes = '05:00'

      }
     
    }, handleChange(val){
                // console.log(val)
                this.StopCycle = val.join();
               console.log(this.StopCycle)
            },
      saveCycles(){
            if(this.checkedCycles.length==0){
                 this.$message({ type: "error", message: "请选择周期" ,duration:1000});
                  return;
            }
 
          this.editSiteSettingInfo(this.SiteSettingID,this.StopCycle);

      },
      saveqjtime(){
          if(this.sTime==''){
               this.$message({ type: "error", message: "请选开始时间" ,duration:1000});
                  return;
          }
          if(this.eTime==''){
                this.$message({ type: "error", message: "请选结束时间" ,duration:1000});
                  return;
          }
           this.tableLoading = true
       var data = { SelectStoresID:this.$route.params.id,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          sTime:this.sTime,
          eTime:this.eTime
         }
     
      
        var that = this
         this.ajax('addSiteLStime.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
                that.tableLoading = false
                that.dialogqjszVisible =false
                that.getList();
                 that.$message({
                type: "success",
                message: res.Msg,duration:2000,
              });
              that.getListSiteLStime()

           } 

      })
      },
      addQjtimeClick(){
        this.sTime='';
        this.eTime='';
       this.dialogqjszVisible=true;
      },
      getList(){

       this.tableLoading = true
       var data = { SelectStoresID:this.$route.params.id,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
    
      }
     
        var that = this
        const loading = this.$loading({
              lock: true,
              text: '加载中...',
              spinner: 'el-icon-loading',
              background: 'rgba(0, 0, 0, 0.7)'
            });
      this.ajax('getListSiteSetting.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
                that.tableLoading = false
                that.SettingList = res.data
            for (let i = 0; i < res.data.length; i++) {
                        
                        if(res.data[i].Ison =='1'){
                        that.SettingList[i].Ison = true;

                        }else{
                        that.SettingList[i].Ison = false;

                        }
                    }
          } 
            loading.close();

      })
  
  
    },deleteQjtimeClick(val){
 this.$confirm("确定要删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
        var data = { SelectStoresID:this.SelectStoresID,        
          StoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          SiteLStimeID:val.ID,
        
        }
        var that = this
        this.ajax('delSiteLStime.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
              that.$message({
                type: "success",
                message: "删除成功",duration:2000,
              });
               that.getListSiteLStime()
             }

        })
        })
        .catch(() => {
            ;
        });
    },
    changeSwitch(val){
                let ison = 0;
               if(val.Ison){
                   ison =1;
               }else{
                   ison =0;
               }

              
               this.editSiteSettingIson(val.ID , ison);
            }, editSiteSettingIson(SttingID,Ison){

       this.tableLoading = true
       var data = { SelectStoresID:this.$route.params.id,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          SiteSettingID:SttingID,
          Ison:Ison
         }
     
      
        var that = this
         this.ajax('editSiteSettingIson.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
                that.tableLoading = false
                that.getList();
                 that.$message({
                type: "success",
                message: res.Msg,duration:2000,
              });
              // if()
                }else{
                   that.getList();

                     that.$message({
                type: "error",
                message: res.Msg,duration:2000,
              });

                 }

      })

            },

            
            editSeetingClick(val){
                val.isEdit = '1';

                    
                if(val.sType == '1'){
                  var str = val.info;
                var arr = str.split(',');
                if(arr.length>0){
                this.checkedCycles = arr;
                }
                this.SiteSettingID =val.ID;
                this.showDrawerzq =true;
                }
                 if(val.sType == '2'){
                      this.SiteSettingID =val.ID;
                this.getListSiteLStime();
                }
                if(val.sType =='16'){
                   this.SiteSettingID =val.ID;

                  this.Selecttimesmt= val.info;

                }
                if(val.sType =='10'){
                   this.SiteSettingID =val.ID;
                  this.SelectDay= val.days;
                   this.Selecttimes = val.info;

                }
                 
             },editsaverClick(val){
                
                 if(val.sType == '1'){
                 
                }else if(val.sType == '2'){
             
                } else if(val.sType == '16'){
                 this.editSiteSettingInfo(val.ID,this.Selecttimesmt);
                }  else if(val.sType == '10'){
                 this.editSiteSettingInfodays(val.ID,this.Selecttimes,this.SelectDay);
                } 
               else{
                 this.editSiteSettingInfo(val.ID,val.info);
               }
                
              },
      getListSiteLStime(){

       this.tableLoading = true
       var data = { SelectStoresID:this.$route.params.id,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
     
      }
     
        var that = this
      this.ajax('ListSiteLStime.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
                that.tableLoading = false
                that.SiteLStimeList = res.data
                that.showqjszRightDrawer = true

          } 

      })
  
  
    },editcancelClick(val){
                val.isEdit = '0';
             }, editSiteSettingInfo(SttingID,info){
                 this.tableLoading = true
       var data = { SelectStoresID:this.$route.params.id,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          SiteSettingID:SttingID,
          info:info
         }
     
      
        var that = this
         this.ajax('editSiteSettingInfo.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
                that.tableLoading = false
                that.getList();
                that.showDrawerzq= false
                 that.$message({
                type: "success",
                message: res.Msg,duration:2000,
              });

                }else{
                     that.$message({
                type: "error",
                message: res.Msg,duration:2000,
              });
                  
                 }

      })

             }, editSiteSettingInfodays(SttingID,info,days){
                 this.tableLoading = true
       var data = { SelectStoresID:this.$route.params.id,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          SiteSettingID:SttingID,
          info:info,
          days:days
         }
     
      
        var that = this
         this.ajax('editSiteSettingInfodays.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
                that.tableLoading = false
                that.getList();
                that.showDrawerzq= false
                 that.$message({
                type: "success",
                message: res.Msg,duration:2000,
              });

                }else{
                     that.$message({
                type: "error",
                message: res.Msg,duration:2000,
              });
                  
                 }

      })

             }    
   
  }
}
</script>
 


// WEBPACK FOOTER //
// src/views/setting/SiteSetting.vue